import React from 'react';
import { Link } from 'react-router-dom';

export default function OutlineButton({ text, url, reverse }) {
  return (
    <Link to={url}>
      {reverse ? (
        <button className="px-4 py-2 font-bold text-white transition-all duration-300 border-2 border-white rounded-md hover:text-white font-brand bg-brandcolor">
          {' '}
          {text}{' '}
        </button>
      ) : (
        <button className="px-4 py-2 font-bold transition-all duration-300 border-2 rounded-md hover:text-white border-brandcolor text-brandcolor font-brand hover:bg-brandcolor">
          {' '}
          {text}{' '}
        </button>
      )}
    </Link>
  );
}
